module.exports = __webpack_public_path__ + "img/homepage_2@2x.a69875bb.jpg";